import { injectGlobal } from 'styled-components';

/* eslint no-unused-expressions: 0 */
injectGlobal`
  html {
    -webkit-tap-highlight-color: transparent;
  }

  body {
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust:100%;
    -ms-text-size-adjust:100%;
    height: 100%;
    width: 100%;
  }

  .app {
    background-color: #fff;
    min-height: 100%;
    min-width: 100%;
    font-size: 10px;
    font-family: 'Raleway', sans-serif;
    color: #333;

    a {
      text-decoration: none;
      color: inherit;
    }
  }


  :focus {
    outline: none;
  }
  .ant-message {
    font-size: 16px!important;
  }
  #icc-container {
    z-index: 9999;
  }
  .ant-tooltip {
    font-size: 14px!important;
  }
`;



// WEBPACK FOOTER //
// ./src/themes/global.js